export interface FrontmatterResult {
  metadata: Record<string, string>;
  content: string;
}

/**
 * Parses YAML frontmatter from a markdown string.
 * Supports simple key: value pairs (no nesting).
 */
export const parseFrontmatter = (raw: string): FrontmatterResult => {
  const match = raw.match(/^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/);

  if (!match) {
    return { metadata: {}, content: raw };
  }

  const [, frontmatterBlock, content] = match;
  const metadata: Record<string, string> = {};

  for (const line of frontmatterBlock.split('\n')) {
    const colonIndex = line.indexOf(':');
    if (colonIndex === -1) continue;
    const key = line.slice(0, colonIndex).trim();
    const value = line.slice(colonIndex + 1).trim();
    if (key) {
      metadata[key] = value;
    }
  }

  return { metadata, content: content.trim() };
};
